import {useMemo} from 'react';
import dayjs from 'dayjs';
import {useTranslation} from 'react-i18next';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import ko from 'dayjs/locale/ko';

dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(timezone);

export const useRelativeTime = (timestamp) => {
    const {i18n} = useTranslation();

    return useMemo(() => {
        if (!timestamp) {
            return null;
        }

        const locale = i18n.language === "ko-KR" ? "ko" : "en";
        dayjs.locale(locale);

        let localizedTimestamp = timestamp;
        if ((typeof localizedTimestamp === "string")
            && (localizedTimestamp.split("+").length > 1)) {
            localizedTimestamp = localizedTimestamp.split("+")[0];
        }

        const backendTimeZone = 'UTC';
        const date = dayjs.tz(localizedTimestamp, backendTimeZone);

        return date.fromNow();
    }, [timestamp, i18n.language]);
};
